import React from 'react';
import { smsService } from 'appConstants';
import { Grid, Tooltip, Link } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useStyles } from './styles';
import PropTypes from 'prop-types';

export default function SMSProviderUI({ smsProvider, formattedPhoneNumber }) {
  const { t } = useTranslation();
  const classes = useStyles();
  let sms = null;
  if (smsProvider) {
    sms = smsService[smsProvider.toUpperCase()];
  }

  return (
    <Grid container direction="row" alignItems="flex-start">
      <Grid item>
        {formattedPhoneNumber}
        {Boolean(sms) && (
          <span className={classes.carrierLink}>
            <Tooltip
              title={t('click_for_terms', 'Click for Terms Of Use')}
              arrow
              placement="top"
              aria-label={t(
                'terms_of_use_opens',
                '{{smsProvider}} terms of use opens in a new window',
                {
                  smsProvider: sms.provider,
                },
              )}
            >
              <Link className={classes.linkStyle} href={sms.link} target="_new noopener noreferrer">
                ({sms.provider})
              </Link>
            </Tooltip>
          </span>
        )}
      </Grid>
    </Grid>
  );
}

SMSProviderUI.propTypes = {
  smsProvider: PropTypes.string,
  formattedPhoneNumber: PropTypes.string,
};
